import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import SpaceBackground from './components/SpaceBackground';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Movies from './pages/Movies';
import MovieDetail from './pages/MovieDetail';
import MoviePlayer from './pages/MoviePlayer';
import WatchParty from './pages/WatchParty';
import WatchPartyRoom from './pages/WatchPartyRoom';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Subscribe from './pages/Subscribe';
import { PrivacyPolicy, Terms, Contact } from './pages/Legal';
import NotFound from './pages/NotFound';
import { AdminMovies } from './pages/Admin';
import './index.css';

// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css';

// Layout wrapper to conditionally show header/footer
const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const noLayoutPaths = ['/room/'];
  const hideLayout = noLayoutPaths.some(path => location.pathname.startsWith(path));

  return (
    <div className="min-h-screen flex flex-col bg-netflix-darker text-white">
      <SpaceBackground />
      {!hideLayout && <Header />}
      <main className="flex-1">
        {children}
      </main>
      {!hideLayout && <Footer />}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/movies" element={<Movies />} />
            <Route path="/movies/:id" element={<MovieDetail />} />
            <Route path="/watch/:id" element={<MoviePlayer />} />
            <Route path="/watchparty" element={<WatchParty />} />
            <Route path="/watch-party" element={<WatchParty />} />
            <Route path="/watch-party/create" element={<WatchParty />} />
            <Route path="/room/:code" element={<WatchPartyRoom />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/subscription" element={<Subscribe />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/movies" element={<AdminMovies />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AppLayout>
      </Router>
    </AuthProvider>
  );
}

export default App;
